import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';
import { PERSONAL_DATA_CATEGORY_DATA_TYPES } from './personal-data-category-types.js';

export {
    PERSONAL_DATA_CATEGORY_DATA_TYPES,
    SPECIAL_PERSONAL_DATA_TYPES,
    PERSONAL_DATA_CATEGORY_DATA_TYPE_OPTIONS,
    isSpecialPersonalDataType,
} from './personal-data-category-types.js';

export const PersonalDataCategorySchema = BigdesDefinitionSchema.extend({
    parentId: z.string().nullable().optional(),
    orderIndex: z.number().default(0),
    isSpecialQualified: z.boolean().default(false),
    dataType: z.enum(PERSONAL_DATA_CATEGORY_DATA_TYPES).default('genel'),
    examples: z.array(z.string()).optional(),
    retentionPeriod: z.string().optional(),
    legalBasis: z.string().optional(),
    sensitivityLevel: z.string().optional(),
    code: z.string().trim().max(80).optional().or(z.literal('')),
    customFields: z.record(z.unknown()).optional(),
});
export const CreatePersonalDataCategorySchema = PersonalDataCategorySchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdatePersonalDataCategorySchema = PersonalDataCategorySchema.omit({ createdAt: true, updatedAt: true }).partial();
